var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.advancedMode ||
      (_vm.referral.BodyPosition !== '' && _vm.referral.BodyPosition !== null)
  )?_c('information-card',{attrs:{"icon":"fas fa-comments","title":"Patiëntligging"}},[_vm._v("\n  "+_vm._s(_vm.referral.BodyPosition || "-")+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }